import React, {useState} from "react";
import { StyleSheet, Text, View, Button, ImageBackground,Dimensions,TouchableOpacity, Alert,Image} from "react-native";
import img1 from './images/clemgram_black.jpg';


import { initializeApp } from "firebase/app";
import { getDatabase, ref, set,update } from "firebase/database";
//<ImageBackground source={imgSrc} resizeMode="cover" style={styles.image}>



//<ImageBackground source={imgSrc} resizeMode="cover" style={styles.image}>
const Info = (props) => {
/*
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const user_id = urlParams.get('uid');
*/
	return( 
		           
		<View style={styles.container}>
						<Text style={styles.text2}>Welcome to Clemgram</Text>
			<View style={styles.buttonContainer}>

			<Text style={styles.text}
			onPress={() => {

				props.navigation.navigate('Infoo',{firstname: '',lastname: '',email: '',pic:'default',bio:'Hello I am using Clemgram!'});
			}}
				>Signup</Text>
				<View style={{flexDirection: 'row', alignItems: 'center'}}>
				<Text style={styles.text2}>       </Text>
  <View style={{ height: 1, width:Dimensions.get('window').width/1.1, backgroundColor: '#FF1493'}} />
</View>
               			
			</View>
			<ImageBackground source={img1}   resizeMode={'center'}
			style={{
				width: Dimensions.get('window').width/1.7,
				height: Dimensions.get('window').height/1.7,
				resizeMode: "center",
				alignSelf: "center",
				paddingTop:0,
				marginTop:0,
				//borderWidth: 1,
				//borderRadius: 1,
			}}>
			
            
			</ImageBackground>
		</View>
       
    )
}
//<Text style={styles.text3}>   You will write each post using our tool. </Text>
                
const styles = StyleSheet.create({
	container: {
		padding: 1,
		flex: 1,
		display: "flex",
		marginTop: 1,
		textAlign: 'center',
		flexDirection: "column",
		justifyContent: "right",
		backgroundColor:"black",
	},
	imageContainer: {
		padding: 1,
		marginTop: 1,
		textAlign: 'center',
        flexDirection: "row",
        paddingLeft: Dimensions.get('window').width/11,
		paddingRight: Dimensions.get('window').width/11,
		justifyContent: "center",
	},
	textContainer: {
		textAlign: 'left',
        flexDirection: "row",
		justifyContent: "right",
	},
	buttonContainer:{
		display: "flex",
		marginTop: 50,
		marginRight: 50,
		textAlign: 'right',
		flexDirection: "column",
		justifyContent: "right",
	},

	text: {
		fontWeight: "bold",
		textDecorationLine: 'underline',
		fontSize: 20,
		color:'#FF1493',
		alignItems: 'left',
		justifyContent: 'left',
		paddingBottom: 1,
	paddingHorizontal: 32,
	paddingTop: 20,
	borderRadius: 1,
	},	 
	 iweb: {
		height:50,
		width: 50,
		
	  },
    text2: {
		fontWeight: "bold",
		fontSize: 35,
		color:'#FFA500',
	paddingTop: 20,
	borderRadius: 1,
	},
    text3: {
		//fontWeight: "bold",
		padding: 10,
		fontSize: 18,
	},
    
    text4: {
		//fontWeight: "bold",
		padding: 30,
		fontSize: 18,
	},
	image: {
		flex: 1,
		justifyContent: "center"
	  },
	buttonStyle: {
	alignItems: 'right',
	justifyContent: 'right',
	paddingVertical: 52,
	paddingHorizontal: 32,
	paddingTop: 20,
	borderRadius: 1,
	borderWidth:10,
	elevation: 13,
	color:"#FFB6C1",
	backgroundColor:"#FFB6C1"
	},
	listContainer: {
		paddingTop: 20
	},
	listItem: {
		fontSize: 20
	},
	textAreaContainer: {
		
		paddingTop: 30,
		paddingRight:270,
		paddingLeft: 270,
		paddingBottom: 30,

	  },
	  textArea: {
		height: 300,
		fontSize: 20,
		borderColor: '#341ada',
		borderWidth: 3,
		justifyContent: "flex-start"
	  }
})
export default Info